import { axios } from '@Root/API'

export const get = params => {
  return axios.get(`student-engagement/rollover-leavers/info`, { params })
}
